import { router } from '@inertiajs/vue3'
import { computed, onUnmounted, ref } from 'vue'

export function useActiveRoute() {
    const currentRoute = ref(route().current())

    // Update route on navigation
    const removeNavigateListener = router.on('navigate', () => {
        currentRoute.value = route().current()
    })

    // Clean up listener when component is unmounted
    onUnmounted(() => {
        removeNavigateListener()
    })

    // Reactive function to check if a route is active
    const isActive = (routeName) => {
        // Force reactivity by accessing currentRoute.value
        currentRoute.value
        const result = route().current(routeName)
        // Optional: Add debug logging
        // console.log(`Checking route '${routeName}' against current '${route().current()}': ${result}`)
        return result
    }

    // Helper to get current route name (reactive)
    const getCurrentRoute = computed(() => currentRoute.value)

    // Helper to check if current route matches any of the provided patterns
    const isAnyActive = (...routeNames) => {
        return routeNames.some((routeName) => route().current(routeName))
    }

    // Helper to get route params (reactive)
    const getRouteParams = computed(() => route().params)

    // Helper to check if route has specific parameters
    const hasParam = (paramName, value = null) => {
        const params = route().params
        if (value === null) {
            return params.hasOwnProperty(paramName)
        }
        return params[paramName] === value
    }

    // Helper to get route name without checking if it's current
    const getRouteName = computed(() => route().current())

    // Helper to check if route matches pattern and has specific params
    const isActiveWithParams = (routeName, paramChecks = {}) => {
        currentRoute.value // Force reactivity
        if (!route().current(routeName)) return false

        return Object.entries(paramChecks).every(([key, value]) => {
            return route().params[key] === value
        })
    }

    return {
        currentRoute: getCurrentRoute,
        isActive,
        isAnyActive,
        getRouteParams,
        hasParam,
        getRouteName,
        isActiveWithParams,
    }
}
